/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BasicUsersAsList } from './basicUsersAsList';
import { ConversationKinds } from './conversationKinds';
import { MessagingChannelBasic } from './messagingChannelBasic';

export interface Conversation { 
    /**
     * Conversation ID
     */
    entity_id: string;
    /**
     * Conversation title text
     */
    title: string;
    kind: ConversationKinds;
    participants: BasicUsersAsList;
    messaging_channel_basic: MessagingChannelBasic;
}